import { useEffect, useRef, useState } from "react";
import './SearchBar.scss';
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ROLES } from "aw-consts";
import { ISelectOptions } from "aw-combobox";
import { AWSelect } from "aw-select";

interface SearchBarProps {
    onClickReload: () => void;
    company: string;
    options: ISelectOptions[];
    selected: ISelectOptions;
    onChangeSelect: (e: any) => void;
    onChangeDates: (e: any) => void;
    defaultIni: string;
    defaultFin: string;
    role: number;
    showEyeButton?: boolean;
    classNameSuccess?: string;
    rounded?: string;
    containerColor?: string;
    dark?: boolean;
    downloadButton?: boolean;
    optionsFilter2?: ISelectOptions[];
    selectedFilter2?: ISelectOptions;
    onChangeSelect2?: (e: any) => void;
    disableMachineSelect: boolean;
    showCompaniesCombo?: boolean;
}

const SearchBar = ({ onClickReload, company, options, selected, onChangeSelect, onChangeDates, defaultIni, defaultFin, role, showEyeButton = false, classNameSuccess = "btn btn-success buttonRadius", rounded = "rounded-3", containerColor = "var(--background-secondary)", dark = false, downloadButton = true, optionsFilter2 = [], selectedFilter2 = { label: "", value: 0 }, onChangeSelect2 = () => {}, disableMachineSelect = false, showCompaniesCombo = true }: SearchBarProps) => {
    const [selectedValue, setSelectedValue] = useState(selected)
    const [selectedValue2, setSelectedValue2] = useState(selectedFilter2)
    const [selectedValue3, setSelectedValue3] = useState(selectedFilter2)
    const [comboOptions, setComboOptions] = useState<ISelectOptions[]>(options)
    const [comboOptions2, setComboOptions2] = useState<ISelectOptions[]>(optionsFilter2)
    const [comboOptions3, setComboOptions3] = useState<ISelectOptions[]>(optionsFilter2)
    const searchButton = useRef<HTMLButtonElement>(null)
    const { t } = useTranslation()

    useEffect(() => {
        setSelectedValue(selected)
        setComboOptions(options)
    }, [options, selected])

    useEffect(() => {
        setSelectedValue2(selectedFilter2)
        setComboOptions2(optionsFilter2)
    }, [optionsFilter2, selectedFilter2])

    const selectChange = (o: any) => {
        const selectedValue = options.filter((c: any) => c.value == o.value)
        setSelectedValue(selectedValue[0])
        onChangeSelect(o)
    }

    const selectChange2 = (o: any) => {
        const selectedValue = optionsFilter2.filter((c: any) => c.value == o.value)
        setSelectedValue2(selectedValue[0])
        onChangeSelect2(o)
    }

    const onClickSearch = () => {
        if (searchButton.current) searchButton.current.disabled = true
        onClickReload()

        setTimeout(() => {
            if (searchButton.current) searchButton.current.disabled = false
        }, 5000)
    }

    return (
        <div className={`p-2 ${rounded} search-bar-container`} style={{ backgroundColor: containerColor }}>
            <div className='d-flex align-items-center flex-column flex-md-row justify-content-md-between gap-md-0 gap-1' >
                <div className='d-flex w-100 w-md-auto flex-sm-grow-0 flex-sm-row flex-column  gap-1'>
                    {showCompaniesCombo && (
                        <div className="d-flex justify-content-end "
                        >
                        <div className='min-w-125 w-50 flex-sm-fill flex-grow-0'>
                            <AWSelect dark={dark} onChange={() => null} disabled={true} options={comboOptions3} value={{ label: company, value: 0 }} />
                        </div>
                        </div>
                    )}
                    <div className="d-flex flex-fill gap-1">
                    <div className='flex-fill flex-md-grow-0 w-50 min-w-125'>
                        <AWSelect dark={dark} onChange={selectChange} options={comboOptions} value={selectedValue} />
                    </div>
                    <div className='flex-fill flex-md-grow-0 w-50 min-w-125'>
                        <AWSelect dark={dark} onChange={selectChange2} disabled={disableMachineSelect} options={comboOptions2} value={selectedValue2} />
                    </div>
                    </div>
                </div>
                <div className='d-flex flex-fill w-sm-auto w-100 flex-sm-row flex-column justify-content-end gap-1' >
                    {role !== ROLES.Provider && (
                        <div className='d-flex flex-fill flex-md-grow-0 gap-1'>
                            <div className='flex-fill '>
                                <Form.Control name='iniDate' className={dark ? "date-picker dark" : "date-picker"} type='date' defaultValue={defaultIni} onChange={onChangeDates} />
                            </div>
                            <div className='flex-fill'>
                                <Form.Control name='finDate' className={dark ? "date-picker dark" : "date-picker"} type='date' defaultValue={defaultFin} onChange={onChangeDates} />
                            </div>
                        </div>
                    )}
                    <div className='ms-auto ms-sm-0'>
                        <button ref={searchButton} onClick={onClickSearch} className={`${classNameSuccess} ${showEyeButton || downloadButton ? "me-2" : ""} mt-0`}>
                            <i className='bi bi-search'></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchBar